'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var mustache = require('mustache');
var nthHookTheme = require('@narvar/nth-hook-theme');
var nthHookSettings = require('@narvar/nth-hook-settings');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var nthKitDynamicLayoutNext = require('@narvar/nth-kit-dynamic-layout-next');
var nthBitHeader = require('@narvar/nth-bit-header');
var MaptilerMap = require('@narvar/nth-block-maptiler-map');
var TextLink = require('@narvar/nth-bit-text-link');
var nthHookContextAnalytics = require('@narvar/nth-hook-context-analytics');
var PickupLocationHoursDisclosure = require('./PickupLocationHoursDisclosure.js');
var PickupLocationDetails_module = require('./PickupLocationDetails.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var mustache__default = /*#__PURE__*/_interopDefaultLegacy(mustache);
var MaptilerMap__default = /*#__PURE__*/_interopDefaultLegacy(MaptilerMap);
var TextLink__default = /*#__PURE__*/_interopDefaultLegacy(TextLink);

const {
  FeatureLayout
} = nthKitDynamicLayoutNext.LayoutTree;
const mapStylesLandscape = {
  flex: '1 0 50%',
  alignItems: 'stretch',
  maxWidth: '25rem'
};
const mapStylesPortrait = {
  flexDirection: 'column',
  height: '12.5rem',
  width: '100%'
};
const PickupLocationDetails = ({
  featureName,
  layout = FeatureLayout.PORTRAIT,
  pickupLocation
}) => {
  const logEvent = nthHookContextAnalytics.useAnalyticsPost();
  const landscape = layout === FeatureLayout.LANDSCAPE;
  const {
    bodytextDefaultNone: textStyle,
    linksNoneDefault: linkDefault,
    linksNoneHover: linkHover,
    linksTrackingDefault: linkSecondaryDefault,
    linksTrackingHover: linkSecondaryHover,
    panelbodyNoneNone: panelbody
  } = nthHookTheme.useTheme();
  const {
    pickupLocation: pickupLocationSettings
  } = nthHookSettings.useSettings();
  const {
    moreInfoLink,
    showMoreInfoLink: showMoreInfoLinkRaw,
    showMap: showMapRaw
  } = pickupLocationSettings || {};
  const showMoreInfoLink = typeof showMoreInfoLinkRaw === 'boolean' ? showMoreInfoLinkRaw : true;
  const showMap = typeof showMapRaw === 'boolean' ? showMapRaw : true;
  const {
    locationGetDirections,
    locationHoursOpenUntil,
    locationHoursOpenFuture,
    locationMoreInfo
  } = nthHookTranslations.useTranslations();
  const {
    name,
    address,
    hours,
    geocode,
    openStatus,
    openStatusTime,
    phoneNumber,
    directionUrl
  } = pickupLocation;
  let openStatusText;
  switch (openStatus) {
    case 'OPEN':
      openStatusText = mustache__default["default"].render(locationHoursOpenUntil || '', {
        closeTime: openStatusTime
      });
      break;
    case 'CLOSED':
      openStatusText = mustache__default["default"].render(locationHoursOpenFuture || '', {
        openDayAndTime: openStatusTime
      });
      break;
    default:
      openStatusText = '';
  }
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: landscape ? PickupLocationDetails_module["default"].rootContainerLandscape : PickupLocationDetails_module["default"].rootContainer
  }, geocode && showMap && /*#__PURE__*/React__default["default"].createElement(MaptilerMap__default["default"], {
    featureName: featureName,
    coordinates: {
      lat: geocode.lat,
      lng: geocode.lng
    },
    s: landscape ? mapStylesLandscape : mapStylesPortrait
  }), /*#__PURE__*/React__default["default"].createElement("div", {
    className: PickupLocationDetails_module["default"].storeDetails,
    style: panelbody
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: PickupLocationDetails_module["default"].storeContact
  }, /*#__PURE__*/React__default["default"].createElement(nthBitHeader.MediumHeader, {
    as: "p",
    featureName: featureName
  }, name), address && /*#__PURE__*/React__default["default"].createElement("address", {
    className: PickupLocationDetails_module["default"].address,
    style: textStyle
  }, address.street1, /*#__PURE__*/React__default["default"].createElement("br", null), address.street2 && /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, address.street2, /*#__PURE__*/React__default["default"].createElement("br", null)), `${address.city || ''}, ${address.state || ''} ${address.zip || ''}`), phoneNumber && /*#__PURE__*/React__default["default"].createElement(TextLink__default["default"], {
    href: `tel:${phoneNumber}`,
    linkStyle: {
      sDefault: {
        ...linkDefault,
        marginTop: '0.5rem',
        display: 'inline-block'
      },
      sHover: linkHover
    },
    onClick: () => logEvent({
      clickCategory: nthHookContextAnalytics.NarvarClickSubTypes.EXTERNAL_LINK,
      clickLinkDestinationUrl: `tel:${phoneNumber}`,
      clickLinkLabel: phoneNumber,
      clickSubType: nthHookContextAnalytics.NarvarClickSubTypes.PICKUP_LOCATION_PHONE_LINK,
      clickType: nthHookContextAnalytics.NarvarClickTypes.OUTGOING,
      eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_PICKUP_LOCATION,
      eventFeature: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_PICKUP_LOCATION,
      eventType: nthHookContextAnalytics.NarvarEventTypes.CLICK,
      feature: featureName,
      pageComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_PICKUP_LOCATION
    })
  }, phoneNumber)), /*#__PURE__*/React__default["default"].createElement("div", {
    className: landscape ? PickupLocationDetails_module["default"].storeHoursLandscape : PickupLocationDetails_module["default"].storeHours
  }, openStatusText && /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      ...textStyle,
      fontWeight: 'bold'
    }
  }, openStatusText), /*#__PURE__*/React__default["default"].createElement(PickupLocationHoursDisclosure["default"], {
    hours: hours,
    featureName: featureName
  }), directionUrl && /*#__PURE__*/React__default["default"].createElement(TextLink__default["default"], {
    href: directionUrl,
    linkStyle: {
      sDefault: {
        ...linkSecondaryDefault,
        fontWeight: 'bold',
        margin: '1rem 1rem 0 0',
        display: 'inline-block',
        wordBreak: 'break-all',
        textDecorationLine: 'none'
      },
      sHover: {
        ...linkSecondaryHover,
        fontWeight: 'bold'
      }
    },
    onClick: () => logEvent({
      clickCategory: nthHookContextAnalytics.NarvarClickSubTypes.EXTERNAL_LINK,
      clickLinkDestinationUrl: directionUrl,
      clickLinkLabel: locationGetDirections,
      clickSubType: nthHookContextAnalytics.NarvarClickSubTypes.PICKUP_LOCATION_DIRECTIONS_LINK,
      clickType: nthHookContextAnalytics.NarvarClickTypes.OUTGOING,
      eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_PICKUP_LOCATION,
      eventFeature: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_PICKUP_LOCATION,
      eventType: nthHookContextAnalytics.NarvarEventTypes.CLICK,
      feature: featureName,
      pageComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_PICKUP_LOCATION
    })
  }, locationGetDirections), showMoreInfoLink && moreInfoLink && /*#__PURE__*/React__default["default"].createElement(TextLink__default["default"], {
    href: moreInfoLink,
    linkStyle: {
      sDefault: {
        ...linkSecondaryDefault,
        fontWeight: 'bold',
        marginTop: '1rem',
        display: 'inline-block',
        wordBreak: 'break-all',
        textDecorationLine: 'none'
      },
      sHover: {
        ...linkSecondaryHover,
        fontWeight: 'bold'
      }
    }
  }, locationMoreInfo))));
};
var PickupLocationDetails$1 = nthHookSettings.withSettingsProvider(nthHookTranslations.withTranslationsProvider(nthHookTheme.withThemeProvider(PickupLocationDetails, {
  themeTokens: ['bodytextDefaultNone', 'linksNoneDefault', 'linksNoneHover', 'linksTrackingDefault', 'linksTrackingHover', 'panelbodyNoneNone']
}), {
  translationKeys: ['locationGetDirections', 'locationHoursOpenUntil', 'locationHoursOpenFuture', 'locationMoreInfo']
}), {
  settingsRequested: `
      pickupLocation {
        moreInfoLink
        showMoreInfoLink
        showMap
      }
    `
});

exports["default"] = PickupLocationDetails$1;
